import React, { useEffect, useState } from "react";
import { IImovelFocus } from "../../../../Pages/Cartorio_Pages/App_Pages/ImovelFocus";
import theme from "../../../../Styles/theme";

import Modal from "react-modal";
import { ModalDivX } from "../../../ModalDivX";
import { Container, SubmitButton, TextArea, DivHandleButton } from "./styles";
import { ModalLoader } from "../../../ModalLoader";
import api from "../../../../Services/api";
import { isRural } from "../../../../Utils/isRural";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: theme.colors.secondary,
    borderRadius: "0.25rem",
  },
};

interface Props {
  imovel: IImovelFocus;
  handleSetImovel(im: IImovelFocus): void;
  open: boolean;
  onClose(): void;
}
export function ModalObservacoes({
  imovel,
  handleSetImovel,
  open,
  onClose,
}: Props) {
  const [observacoes, setObservacoes] = useState("");
  const [loading, setLoading] = useState(false);

  async function post() {
    setLoading(true);
    try {
      const { data } = await api.patch(`/imovel${isRural() ? "-rural" : ""}/observacoes`, {
        ID: imovel.ID,
        OBSERVACOES: observacoes,
      });
      imovel.OBSERVACOES = observacoes;
      handleSetImovel(imovel);
      onClose();
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (imovel.OBSERVACOES) {
      setObservacoes(imovel.OBSERVACOES);
    }
  }, [open]);

  return (
    <Modal isOpen={open} onRequestClose={onClose} style={customStyles}>
      <ModalDivX execute={onClose} />
      <Container>
        <TextArea
          onChange={(ev) => setObservacoes(ev.target.value)}
          value={observacoes}

        
          maxLength={2500}
        ></TextArea>
      </Container>
      <DivHandleButton>
        <SubmitButton onClick={post}>CONFIMAR</SubmitButton>
      </DivHandleButton>
      <ModalLoader loading={loading} />
    </Modal>
  );
}
